/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2020, Bulb Inc. For more information, please email contact@hellobulb.com.
 *          _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
*/

import {
  Directive, AfterViewInit, ElementRef, Input,
} from '@angular/core';

/**
 * An attribute directive that accepts a boolean value stating whether or not to apply
 * focus to the element it is applied to.
 */
@Directive({
  selector: '[bulbAutofocus]',
  standalone: false,
})

export class AutofocusDirective implements AfterViewInit {
/**
 * Variable that accepts boolean value when directive is applied to element.
 */
  @Input('bulbAutofocus') public isAutofocusEnabled : boolean;

  constructor(private elementRef: ElementRef) { }

  ngAfterViewInit() {
    if (this.isAutofocusEnabled) {
      this.elementRef.nativeElement.focus();
    }
  }
}
